<template>
  <div class="new-admin">
    <modal
      :customerClass="'modal-type-dialog'"
      :show.sync="show"
      :large="true"
      @cancel="onClose"
    >
      <div slot="header">
        <h3 class="title">Edit Admin</h3>
      </div>
      <admin-form :struct="formStruct" @update="updateData" />
      <div slot="footer">
        <b-button variant="modal" @click="onClose()"> discard </b-button>
        <b-button variant="modal" @click="onSubmit()"> save </b-button>
      </div>
    </modal>
  </div>
</template>

<script>
import adminForm from "./form";
import modal from "../shared/modal";
const helper = require("./helper");

export default {
  name: "edit-admin",
  components: { adminForm, modal },
  data() {
    return {
      formStruct: helper.serialize(this.item),
      data: {}
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onSubmit() {
      var form = this.$children[0].$children[0];
      form.validateAll();
      if (form.isValid()) {
        var params = helper.deserialize(this.data);
        this.$store.dispatch("updateAdmin", {
          id: this.item.id,
          params: params
        });
        this.onClose();
      }
    },
    updateData(data) {
      this.data = data;
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  }
};
</script>
